export default "__VITE_ASSET__CTxhUQM1__"